import Contest from "../interfaces/Contest";

export const ContestCategories = [
  "ABC",
  "ARC",
  "AGC",
  "AWC",
  "PAST",
  "Heuristic",
  "Other",
] as const;
export type ContestCategory = typeof ContestCategories[number];

export const AGC_001_START = 1468670400;

const HIDDEN_PROBLEM_IDS = new Set([
  "future_contest_2020_final_2_b",
  "future_contest_2020_final_b",
  "future_contest_2020_qual_b",
  "yamato_contest2019_a",
  "yamato_contest2019_b",
  "future_contest_2019_final_b",
  "future_contest_2019_qual_b",
  "future2018career_b",
  "practice_1",
  "practice_2",
  "APG4b_aa",
  "APG4b_ab",
  "APG4b_ac",
  "APG4b_ad",
  "APG4b_ae",
  "APG4b_af",
  "APG4b_ag",
  "APG4b_ah",
  "APG4b_ai",
  "APG4b_aj",
  "APG4b_ak",
  "APG4b_al",
  "APG4b_am",
  "APG4b_an",
  "APG4b_b",
  "APG4b_c",
  "APG4b_d",
  "APG4b_e",
  "APG4b_f",
  "APG4b_g",
  "APG4b_h",
  "APG4b_i",
  "APG4b_j",
  "APG4b_k",
  "APG4b_l",
  "APG4b_m",
  "APG4b_n",
  "APG4b_o",
  "APG4b_p",
  "APG4b_q",
  "APG4b_r",
  "APG4b_s",
  "APG4b_t",
  "APG4b_u",
  "APG4b_v",
  "APG4b_w",
  "APG4b_x",
  "APG4b_y",
  "APG4b_z",
  "APG4bPython_ak",
  "APG4bPython_al",
  "APG4bPython_b",
  "APG4bPython_c",
  "APG4bPython_d",
  "APG4bPython_e",
  "APG4bPython_f",
  "APG4bPython_g",
  "APG4bPython_h",
  "APG4bPython_i",
  "APG4bPython_j",
  "APG4bPython_k",
  "APG4bPython_l",
  "APG4bPython_m",
  "APG4bPython_n",
  "awtf2025heuristic_b",
]);

export const isHiddenProblem = (problemId: string): boolean =>
  HIDDEN_PROBLEM_IDS.has(problemId);

export const isRatedContest = (
  contest: Contest,
  problemCount: number
): boolean => {
  return (
    contest.rate_change !== "-" &&
    contest.start_epoch_second >= AGC_001_START &&
    problemCount >= 2
  );
};

export const classifyContest = (contest: Contest): ContestCategory | "ADT" => {
  if (/^abc\d{3}$/.exec(contest.id)) {
    return "ABC";
  }
  if (/^arc\d{3}$/.exec(contest.id)) {
    return "ARC";
  }
  if (/^agc\d{3}$/.exec(contest.id)) {
    return "AGC";
  }
  if (/^awc\d{4}$/.exec(contest.id)) {
    return "AWC";
  }
  if (/^adt_/.exec(contest.id)) {
    return "ADT";
  }
  if (
    /^ahc\d{3}$/.exec(contest.id) ||
    ["toyota2023summer-final"].includes(contest.id) ||
    /(^Chokudai Contest|ハーフマラソン|^HACK TO THE FUTURE|Asprova|Heuristics Contest)/.exec(
      contest.title
    ) ||
    /(^future-meets-you-contest|^hokudai-hitachi|^toyota-hc)/.exec(
      contest.id
    ) ||
    [
      "toyota2023summer-final-open",
      "genocon2021",
      "stage0-2021",
      "caddi2019",
      "pakencamp-2019-day2",
      "kuronekoyamato-contest2019",
      "wn2017_1",
      "masters2026-final",
      "masters2026-final-open",
      "masters2026-qual",
      "masters2025-final",
      "masters2025-final-open",
      "masters2025-qual",
      "masters2024-final",
      "masters2024-final-open",
      "masters-qual",
      "atcoder12live",
      "atcoder11live",
      "newjudge-2308-heuristic",
      "ddcc2019-machine",
      "awtf2025heuristic",
    ].includes(contest.id)
  ) {
    return "Heuristic";
  }
  if (contest.id.startsWith("past")) {
    return "PAST";
  }

  return "Other";
};
